import "./SignUp.scss";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { Button, Typography } from "../../ui";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import Visibility from "@material-ui/icons/Visibility";
import InputAdornment from "@material-ui/core/InputAdornment";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { StylesProvider } from "@material-ui/core/styles";
import { IS_PROD, PUBLIC_URL } from "../../configs/main";
import { RETARGEO_DOC_FILES, getRetargeoDocUrl } from "../../configs/retargeoDocs";
import country_phone from "./CountryPhoneList";
import { isValidPhoneNumber } from 'libphonenumber-js';

import { ReactComponent as LogoWhiteIcon } from "../../assets/images/logo-white.svg";
import LogoWhiteIconRetargeo from "../../assets/images/retargeo-logo-white.jpg";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useState, useEffect, useRef, useMemo } from "react";
import * as Yup from "yup";
import TelephoneInput from "../../widgets/TelephoneInput/TelephoneInput";
import { client } from "../../utils/network";
import { getOrCreateSessionId, trackSignupVisit } from "../../utils/productEvents";
import ReactFlagsSelect from "react-flags-select";
import { useDispatch } from "react-redux";
import useUser from "../../data/useUser";
import { setUserData } from "../../redux/user/actions";
import { getDomainConfig } from "../../configs/main";
import { useDispatch as useReduxDispatch } from "react-redux";
import { setSupportOrigin } from "../../redux/pageContext/actions";

const RETARGEO_METRIKA_ID = 108716716;

const RUSSIAN_EMAIL_TLD_REGEX = /(\.ru|\.рф|\.xn--p1ai)$/iu;

const isRussianEmailDomain = (email) => RUSSIAN_EMAIL_TLD_REGEX.test(email.trim().toLowerCase());

const getSignUpValidationSchema = (isManagerMode) => {
  let emailSchema = Yup.string().trim()
    .required("Это обязательное поле")
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/u, "Введен некорректный Email");

  if (!isManagerMode) {
    emailSchema = emailSchema.test(
      "russian-email-domain",
      "Регистрация доступна только с почтовых адресов в зонах .ru и .рф",
      (value) => !value || isRussianEmailDomain(value)
    );
  }

  return Yup.object().shape({
    first_name: Yup.string().required("Это обязательное поле")
      .matches(/^[а-яА-Я\s-]+$/, "Допустимы символы русского, пробелы и дефисы"),
    surname: Yup.string().required("Это обязательное поле")
      .matches(/^[а-яА-Я\s-]+$/, "Допустимы символы русского, пробелы и дефисы"),
    email: emailSchema,
    phone_number: Yup.string().required(
      "Это обязательное поле"
    ),
    password: Yup.string().required("Поле Пароль не может быть пустым")
      // eslint-disable-next-line no-useless-escape
      .matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+=\[{\]};:<>|./?,-]).{8,}$/, 'Пароль должен содержать не менее 8 символов, латинские буквы верхнего и нижнего регистра, хотябы одну цифру и специальный символ'),
    password_again: Yup.string().required(
      "Это обязательное поле"
    )
      .oneOf([Yup.ref('password')], 'Пароли не совпадают'),
    role: Yup.string(),
    is_entity: Yup.boolean(),
    registration_type: Yup.string(),
  });
};

const isSignUpFormValid = (formValues, countryCode, isManagerMode) => {
  try {
    getSignUpValidationSchema(isManagerMode).validateSync(formValues, { abortEarly: false });
    return isValidPhoneNumber(formValues.phone_number, countryCode);
  } catch {
    return false;
  }
};

const initRetargeoYandexMetrika = () => {
  const metrikaSrc = `https://mc.yandex.ru/metrika/tag.js?id=${RETARGEO_METRIKA_ID}`;
  if (Array.from(document.scripts).some((script) => script.src === metrikaSrc)) {
    if (typeof ym !== 'undefined') { // eslint-disable-line no-undef
      ym(RETARGEO_METRIKA_ID, 'init', { // eslint-disable-line no-undef
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: "dataLayer",
        referrer: document.referrer,
        url: location.href,
        accurateTrackBounce: true,
        trackLinks: true,
      });
    }
    return;
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.innerHTML = `
    (function(m,e,t,r,i,k,a){
      m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)
    })(window, document,'script','${metrikaSrc}', 'ym');

    ym(${RETARGEO_METRIKA_ID}, 'init', {ssr:true, webvisor:true, clickmap:true, ecommerce:"dataLayer", referrer: document.referrer, url: location.href, accurateTrackBounce:true, trackLinks:true});
  `;
  document.head.appendChild(script);
};


// const saveDataInLocalStorage = (isSave) => {
//   return localStorage.setItem(
//     "programmatic_save_password",
//     isSave ? "true" : "false"
//   );
// };

function SignUp() {
  const isRetargeo = getDomainConfig().brand === 'retargeo';
  const formCompleteGoalSent = useRef(false);

  // eslint-disable-next-line no-unused-vars
  const [isOfferta, setIsOfferta] = useState(true);
  const [target, setTarget] = useState(false);
  const [country_code, setCountry] = useState("+7");
  const [selected, setSelected] = useState("RU");

  const dispatch = useDispatch();
  const rDispatch = useReduxDispatch();
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const [isForeignEmailModalOpen, setIsForeignEmailModalOpen] = useState(false);
  const supportEmail = "techsupport@retargeo.ru";
  const encodedSupportEmail = encodeURIComponent(supportEmail);
  const emailClients = [
    {
      label: "mail.ru",
      url: `https://e.mail.ru/compose/?to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/mail.ru",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=mail.ru&sz=64",
    },
    {
      label: "Яндекс Почта",
      url: `https://mail.yandex.ru/compose?to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/yandex.ru",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=yandex.ru&sz=64",
    },
    {
      label: "Gmail",
      url: `https://mail.google.com/mail/?view=cm&fs=1&to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/gmail.com",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=gmail.com&sz=64",
    },
    {
      label: "Microsoft Outlook",
      url: `https://outlook.office.com/mail/deeplink/compose?to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/outlook.com",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=outlook.com&sz=64",
    },
    {
      label: "iCloud Mail",
      url: `https://www.icloud.com/mail/compose?to=${encodedSupportEmail}`,
      iconUrl: "https://logo.clearbit.com/icloud.com",
      fallbackIconUrl: "https://www.google.com/s2/favicons?domain=icloud.com&sz=64",
    },
  ];

  const handleSupportClick = () => {
    rDispatch(setSupportOrigin("auth_signup_button"));
    setIsSupportModalOpen(true);
  };

  const handleClientSelect = (url) => {
    window.open(url, "_blank");
    setIsSupportModalOpen(false);
  };
  

  useEffect(()=> {
    country_phone.data.map((item) => item.code === selected ? setCountry(item.dial_code) : "")
  },[selected])

  useEffect(() => {
    if (!isRetargeo) return;
    initRetargeoYandexMetrika();
  }, [isRetargeo]);


  const [emailConfrim, setEmailConfirm] = useState(false)
  const [count, setCount] = useState(60);
  const [showPassword, setShowPassword] = useState(false);
  const { mutate: userMutate } = useUser();
  const navigate = useNavigate();

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const [showRepeatPassword, setShowRepeatPassword] = useState(false);

  const handleClickShowRepeatPassword = () => {
    setShowRepeatPassword(!showRepeatPassword);
  };

  const handleMouseDownRepeatPassword = (event) => {
    event.preventDefault();
  };

  const setButtonsDisabled = (disabled) => {
    for (let button of document.getElementsByClassName('Button')) {
      button.disabled = disabled;
    }
  }

  const timer = () => {
    const id = setInterval(() => {
      setCount((prev) => {
        if (prev === 0) {
          clearInterval(id)
        }
        return prev > 0 ? prev - 1 : 0
      });
    }, 1000)
  }

  useEffect(() => {
    if (emailConfrim) {
      timer();
    }
  }, [emailConfrim])

  const handleClickEmailConfirm = async () => {
    if (count === 0) {
      client.post("/api/v1/auth/email/resend", {
        email: values.email
      })
      setCount(60);
      timer();
    }
  }

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const refParam = searchParams.get('ref');
  const isManagerMode = location.pathname.endsWith('/manager');
  const registrationTitleClicksRef = useRef(0);

  const validationSchema = useMemo(
    () => getSignUpValidationSchema(isManagerMode),
    [isManagerMode]
  );

  useEffect(() => {
    if (!isManagerMode) {
      registrationTitleClicksRef.current = 0;
    }
  }, [isManagerMode]);

  useEffect(() => {
    if (!isManagerMode) {
      trackSignupVisit();
    }
  }, [isManagerMode]);

  const handleRegistrationTitleClick = () => {
    if (isManagerMode) return;
    registrationTitleClicksRef.current += 1;
    if (registrationTitleClicksRef.current >= 5) {
      registrationTitleClicksRef.current = 0;
      navigate('/sign-up/manager');
    }
  };


  const saveDataInLocalStorage = (isSave) => {
    return localStorage.setItem(
      "programmatic_save_password",
      isSave ? "true" : "false"
    );
  };


  const {
    errors,
    setErrors,
    values,
    handleChange,
    handleSubmit,
    setFieldValue,
    touched,
    handleBlur,
  } = useFormik({
    initialValues: {
      first_name: "",
      surname: "",
      email: "",
      phone_number: "",
      inn: null,
      role: "DEFAULT",
      password_again: "",
      password: "",
      is_entity: true,
      registration_type: "advertiser",
    },
    validationSchema,
    onSubmit: async (values) => {
      if (isRetargeo && typeof ym !== 'undefined') { // eslint-disable-line no-undef
        ym(RETARGEO_METRIKA_ID, 'reachGoal', '930202'); // eslint-disable-line no-undef
      }
      setButtonsDisabled(true);
      try {
        values.email = values.email.trim()
        const payload = {
          ...values,
          inn: null,
          session_id: getOrCreateSessionId(),
        };

        await client.post("/api/v1/auth/registration" + (refParam ? `?ref=${refParam}` : ""), payload);
        if (IS_PROD === 'true') {
          ym(94151763, 'reachGoal', 'register'); // eslint-disable-line no-undef
        }

        if (refParam) {
          const params = new URLSearchParams();
          params.append("username", values.email.trim());
          params.append("password", values.password);
          const { data } = await client.post("/api/v1/auth/access-token", params);
          saveDataInLocalStorage(values.isSavePassword);
          localStorage.setItem("token", data.access_token);
          const user = await userMutate();
          dispatch(setUserData(user));
          return navigate("/");
        }

        setEmailConfirm(true)
      } catch (error) {
        if (error.message === '{"detail":"Пользователь с данным email уже существует"}') {
          setErrors({ ...errors, email: 'Пользователь с таким email уже зарегистрирован' });
        } else if (error.message === '{"detail":"Пользователь с данным номером телефона уже существует"}') {
          setErrors({ ...errors, phone_number: 'Пользователь с таким номером телефона уже зарегистрирован' });
        } else {
          try {
            const errObj = JSON.parse(error.message);
            if (Array.isArray(errObj.detail)) {
              const emailError = errObj.detail.find(
                (item) => item.type === 'value_error.email' || (item.msg && item.msg.includes('valid email'))
              );
              if (emailError) {
                setErrors({ ...errors, email: 'Введен некорректный Email' });
                setButtonsDisabled(false);
                return;
              }
            }
          } catch (e) { /* ignore */ }
          setErrors({ ...errors, response: error.message });
        }
      }
      setButtonsDisabled(false);
    },
  });

  useEffect(() => {
    if (!isRetargeo || emailConfrim || formCompleteGoalSent.current) return;
    if (!isSignUpFormValid(values, selected, isManagerMode)) return;
    if (typeof ym === 'undefined') return; // eslint-disable-line no-undef
    ym(RETARGEO_METRIKA_ID, 'reachGoal', '930201'); // eslint-disable-line no-undef
    formCompleteGoalSent.current = true;
  }, [values, selected, isRetargeo, emailConfrim, isManagerMode]);

  const handleInput = (e) => {
    handleChange(e);
    setErrors({});
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!isManagerMode) {
      const trimmedEmail = values.email.trim();
      if (
        trimmedEmail
        && /^[^\s@]+@[^\s@]+\.[^\s@]+$/u.test(trimmedEmail)
        && !isRussianEmailDomain(trimmedEmail)
      ) {
        setIsForeignEmailModalOpen(true);
      }
    }
    handleSubmit(e);
  };
  // const handleChangeCheckbox = () => {
  //   // setIsSavePassword((prev) => !prev);
  //   setIsOfferta((prev) => !prev);
  //   setErrors({});
  // };

  const handleClick = () => {
    if (getDomainConfig().brand === 'retargeo') {
      window.open(getRetargeoDocUrl(RETARGEO_DOC_FILES.oferta));
    } else {
      window.open(`${PUBLIC_URL}/publichnyj_dogovor-oferta.pdf`);
    }
  };

  const metricChange = () => {
    if (IS_PROD === 'true') {
      if (!target) {
        setTarget(true);
        ym(94151763, 'reachGoal', 'form_start');  // eslint-disable-line no-undef
      }
    }
  }
  return (
    <div className="SignUp">
      {isRetargeo && (
        <noscript>
          <div>
            <img src={`https://mc.yandex.ru/watch/${RETARGEO_METRIKA_ID}`} style={{ position: 'absolute', left: '-9999px' }} alt="" />
          </div>
        </noscript>
      )}
      <div className="images">
        <Link to="/">
          {getDomainConfig().brand === 'retargeo' ? <img width={350} src={LogoWhiteIconRetargeo} className="logo" alt="" /> : <LogoWhiteIcon className="logo" />}
        </Link>

        <div className="greetings">
          <Typography className="greetings-title" variant="h1" color="white">
            Приветствуем Вас!
          </Typography>
          <Typography variant="h1" color="white">
            {getDomainConfig().brand === 'retargeo' ? 'Программный RTB комплекс retargeo.ru - это полностью российская разработка для управления цифровой рекламой и данными.' : 'Программный RTB комплекс Programmatic.ru - это полностью российская разработка для управления цифровой рекламой и данными.'}
          </Typography>
        </div>
      </div>
      <form className="wrapp" autoComplete="off" onSubmit={handleFormSubmit} onChange={metricChange}>
        <div className="form">
          <div
            className="form-title"
            style={{ fontWeight: "bold", fontSize: "32px" }}
            onClick={handleRegistrationTitleClick}
          >
            Регистрация
          </div>
          {!emailConfrim && (
            <div className={`registration-notice${isManagerMode ? " registration-notice--manager" : ""}`}>
              {isManagerMode
                ? "Регистрация в режиме менеджера. Ограничение на домены .ru и .рф не применяется."
                : "В соответствии с законодательством регистрация доступна только с почтовых адресов в зонах .ru и .рф"}
            </div>
          )}
          {!emailConfrim && <Typography className="sub-title" variant="h2" color="dark-gray">
            Всего несколько действий и Вы — участник нашего проекта!
          </Typography>}
          {!emailConfrim && (
            <RadioGroup
              aria-label="registration_type"
              name="registration_type"
              value={values.registration_type}
              onChange={(e) => {
                setFieldValue("registration_type", e.target.value);
              }}
              sx={{
                marginBottom: "20px",
                flexDirection: "row",
                gap: "20px",
              }}
            >
              <FormControlLabel
                value="advertiser"
                control={<Radio />}
                label="Рекламодатель"
              />
              {/* {getDomainConfig().brand === 'retargeo' && (
                <FormControlLabel
                  value="agency"
                  control={<Radio />}
                  label="Агентство"
                />
              )} */}
            </RadioGroup>
          )}
          {emailConfrim && <div>
            <Typography className="confirm_text">
              На Ваш электронный адрес было отправлено письмо. Для завершения регистрации откройте его и подтвердите свою почту.
            </Typography>
            <Button type="button" className="btnConfirm" onClick={() => handleClickEmailConfirm()}>
              Отправить еще раз {count === 60 ? "01:00" : count < 10 ? `00:0${count}` : `00:${count}`}
            </Button>
            <Typography className="textLink">
              У вас уже есть аккаунт? <Link className="link" to="/sign-in">Войти</Link>
            </Typography>
          </div>}
          {!emailConfrim && <><form className="signUp-form">
            <div className="validate_input">
              <input
                id="email"
                name="email"
                className={errors.email && touched.email ? "email-field err" : "email-field"}
                type="email"
                placeholder="Email"
                value={values.email.trim()}
                onChange={handleInput}
                onBlur={handleBlur}
              />
              {touched.email && errors.email ? (
                <div className="error_text">{errors.email}</div>
              ) : null}
            </div>
            <div className="validate_input">
              <input
                id="first_name"
                name="first_name"
                className={errors.first_name && touched.first_name ? "name-field err" : "name-field"}
                type="text"
                placeholder="Имя"
                value={values.first_name}
                onChange={handleInput}
                onBlur={handleBlur}
              />
              {touched.first_name && errors.first_name ? (
                <div className="error_text">{errors.first_name}</div>
              ) : null}
            </div>
            <div className="validate_input">
              <input
                id="surname"
                name="surname"
                className={errors.surname && touched.surname ? "name-field err" : "name-field"}
                type="text"
                placeholder="Фамилия"
                value={values.surname}
                onChange={handleInput}
                onBlur={handleBlur}
              />
              {touched.surname && errors.surname ? (
                <div className="error_text">{errors.surname}</div>
              ) : null}
            </div>
            <div className="validate_input">
              <div style={{ display: 'flex' }}>
                <ReactFlagsSelect
                  className={(errors.phone_number && touched.phone_number) || 
                    (touched.phone_number && !isValidPhoneNumber(values.phone_number, selected))
                     ? "flags-select err" : "flags-select"}
                  selected={selected}
                  selectedSize={10}
                  selectButtonClassName="menu-flags-button"
                  onSelect={(code) => setSelected(code)}
                  showSelectedLabel={false}
                  showOptionLabel={false}
                />
                <div className={(errors.phone_number && touched.phone_number) || 
                    (touched.phone_number && !isValidPhoneNumber(values.phone_number, selected))
                     ? "phone_element err" : "phone_element"} >
                  {country_code}
                </div>
                <TelephoneInput
                  id="phone_number"
                  name="phone_number"
                  className={(errors.phone_number && touched.phone_number) || 
                    (touched.phone_number && !isValidPhoneNumber(values.phone_number, selected)) 
                    ? "phone-field err" : "phone-field"}
                  onChange={(e) => setFieldValue('phone_number', `${country_code}${e.target.value}`)}
                  onBlur={handleBlur}
                  value={values.phone_number}
                  // mask={PHONE_MASK}
                />
              </div>
              {touched.phone_number && errors.phone_number ? (
                <div className="error_text">{errors.phone_number}</div>
              ) : null}
              {touched.phone_number && !isValidPhoneNumber(values.phone_number, selected) ?
                <div className="error_text">Введите корректный номер</div>
                : null}
            </div>
            <StylesProvider injectFirst>
              <div className="validate_input">
                <Input
                  disableUnderline={true}
                  autoComplete="new-password"
                  id="password"
                  name="password"
                  className={errors.password && touched.password ? "password-field err" : "password-field"}
                  type={showPassword ? "text" : "password"}
                  placeholder="Пароль"
                  value={values.password}
                  onChange={handleInput}
                  onBlur={handleBlur}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {touched.password && errors.password ? (
                  <div className="error_text">{errors.password}</div>
                ) : null}
              </div>
              {/* <span className="helpfullText">8-64 символа, минимум один символ в нижнем регистре, один символ в верхнем регистре, одна цифра и один спецсимвол</span> */}
              <div className="validate_input">
                <Input
                  disableUnderline={true}
                  id="password_again"
                  name="password_again"
                  className={errors.password_again && touched.password_again ? "password-field err" : "password-field"}
                  type={showRepeatPassword ? "text" : "password"}
                  value={values.password_again}
                  onChange={handleInput}
                  onBlur={handleBlur}
                  placeholder="Подтвердите пароль"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleClickShowRepeatPassword}
                        onMouseDown={handleMouseDownRepeatPassword}
                      >
                        {showRepeatPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                {touched.password_again && errors.password_again ? (
                  <div className="error_text">{errors.password_again}</div>
                ) : null}
              </div>
            </StylesProvider>
            {/* <div className="save-password">
              <div
                className="remember unselectable"
                onClick={handleChangeCheckbox}
              >
                <Checkbox
                  onChange={handleChangeCheckbox}
                  value={isSavePassword}
                />
                <Typography variant="body1" color="dark-gray">
                  запомнить пароль
                </Typography>
              </div>
            </div> */}
            <RadioGroup
              aria-label="is_entity"
              name="is_entity"
              defaultValue="entity"
              onChange={(e) => {
                handleInput(e);
                setFieldValue("is_entity", !values.is_entity);
              }}
              sx={{
                marginBottom: "10px",
              }}
            >
              <div className="field-radio">
                {/* <FormControlLabel
                  disabled
                  value="individual"
                  control={<Radio />}
                  label="Я физическое лицо"
                /> */}
                <FormControlLabel
                  value="entity"
                  control={<Radio />}
                  label="Я юридическое лицо"
                />
              </div>
            </RadioGroup>
          </form>
            <div className="save-password">
              <div
                className="remember unselectable"
              // onClick={handleChangeCheckbox}
              >
                {getDomainConfig().brand === 'programmatic' ? (
                  <div className="offerta" style={{ textAlign: 'left' }}>
                    Нажимая кнопку “Зарегистрироваться”, вы принимаете условия
                    <button onClick={() => window.open(`https://programmatic.ru/oferta/`)}>
                      оферты
                    </button>,
                    <button onClick={() => window.open(`https://programmatic.ru/soglasie_na_obrabotku_personalnyh_dannyh/`)}>
                    Согласие на обработку персональных данных
                    </button> и
                    <button onClick={() => window.open(`https://programmatic.ru/politika_konfidencialnosti/`)}>
                    Политику конфиденциальности
                    </button>
                  </div>
                ) : (
                  <div className="offerta">
                    Нажимая кнопку “Зарегистрироваться”, вы принимаете условия
                    <button onClick={handleClick}>
                      оферты
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="btn-actions">
              <Button type="submit" variant="primary" className="primary">
                Зарегистрироваться
              </Button>
              <Link to="/sign-in">
                <Button variant="secondary">Войти</Button>
              </Link>
              {
                (getDomainConfig().brand === "retargeo" || getDomainConfig().title === "Programmatic Beta") && (
                  <Button
                  type="button"
                  variant="secondary"
                  style={{ marginTop: 10 }}
                    onClick={handleSupportClick}
                >
                  Связаться с поддержкой
                </Button>
                )
              }
              {isSupportModalOpen && (
                <div
                  style={{
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.45)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000,
                  }}
                  onClick={() => setIsSupportModalOpen(false)}
                >
                  <div
                    style={{
                      width: "100%",
                      maxWidth: 420,
                      backgroundColor: "#fff",
                      borderRadius: 10,
                      padding: 20,
                      boxSizing: "border-box",
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div style={{ fontSize: 18, fontWeight: 600 }}>Выберите почтовый клиент</div>
                    {emailClients.map((client) => (
                      <button
                        key={client.label}
                        style={{
                          width: "100%",
                          padding: "10px 12px",
                          border: "1px solid #d9d9d9",
                          borderRadius: 8,
                          backgroundColor: "#fff",
                          cursor: "pointer",
                          textAlign: "left",
                          fontSize: 14,
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                        }}
                        onClick={() => handleClientSelect(client.url)}
                      >
                        <img
                          src={client.iconUrl}
                          alt={client.label}
                          onError={(e) => {
                            if (e.currentTarget.src !== client.fallbackIconUrl) {
                              e.currentTarget.src = client.fallbackIconUrl;
                            }
                          }}
                          style={{
                            width: 24,
                            height: 24,
                            borderRadius: "50%",
                            objectFit: "cover",
                            flexShrink: 0,
                            border: "1px solid #e5e5e5",
                          }}
                        />
                        {client.label}
                      </button>
                    ))}
                    <button
                      style={{
                        marginTop: 4,
                        width: "100%",
                        padding: "10px 12px",
                        border: "none",
                        borderRadius: 8,
                        backgroundColor: "#f2f2f2",
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                      onClick={() => setIsSupportModalOpen(false)}
                    >
                      Отмена
                    </button>
                  </div>
                </div>
              )}
            </div></>}
        </div>
      </form>
      {isForeignEmailModalOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={() => setIsForeignEmailModalOpen(false)}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 490,
              backgroundColor: "#fff",
              borderRadius: 10,
              padding: 24,
              boxSizing: "border-box",
              display: "flex",
              flexDirection: "column",
              gap: 16,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ fontSize: 18, fontWeight: 600 }}>Используйте российскую почту</div>
            <div style={{ fontSize: 14, lineHeight: 1.6, color: "#42454c" }}>
              Федеральный закон <b>№ 406-ФЗ</b> регулирует использование иностранных сервисов и ограничивает
              применение иностранных почтовых служб для регистрации и входа на российских сайтах.
              <br /><br />
              Пожалуйста, укажите адрес электронной почты в зонах .ru или .рф.
            </div>
            <button
              type="button"
              style={{
                width: "100%",
                padding: "10px 12px",
                border: "none",
                borderRadius: 8,
                backgroundColor: "#3f73f9",
                color: "#fff",
                cursor: "pointer",
                fontSize: 14,
                fontWeight: 500,
              }}
              onClick={() => setIsForeignEmailModalOpen(false)}
            >
              Понятно
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default SignUp;
